import CANNON from "cannon";

let instance = null;

class DiceMaterial {

    constructor() {
        if(!instance)
        {
            this.material = new CANNON.Material();
            instance = this;
        }
        return instance;
    }
}

export default DiceMaterial;

